export const getToken = () => {
  return localStorage.getItem("jwtToken");
};
const fetchPutResponse = (apiEndpoint: string, requestBody: any) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  return fetch(`${apiUrl}/${apiEndpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(requestBody),
  });
};

export const queryEmgpt = async (query: string) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const requestBody = {
      query: query,
    };
    const response = await fetch(`${apiUrl}/conversation:query_chat_gpt`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

export const fetchNews = async (setNewsArticles: any) => {
  try {
    const requestBody = {
      locale: "en",
      category_theme: [
        "INDIAMONS",
        "INDGDP",
        "INDIABONDS",
        "INDIADEFIC",
        "INDINTRATE",
        "INDCONGRESS",
        "INDIADEBT",
        "INDIAEXPORTS",
        "INDEQTMKT",
        "INDIAETCD",
        "INDBLOC",
        "INDBNDYLD",
        "INDIAIMPORTS",
        "INDBJP",
        "INDIAECON",
        "INDIAPNOTES",
        "INDIAFXRESV",
        "INDIAFPI",
        "INDIAIPO",
        "INDRAHULGNDHI",
        "INDIARBI",
        "INDIAFDI",
        "INDINFLTN",
        "INDIAPCHID",
        "INDIABUD",
        "INDIADERIV",
        "INDIAEXPRES",
        "INDMODI",
        "INDIARUPEE",
      ],
      start_date: "2020-12-01",
      end_date: "2024-04-01",
      limit: 100,
      offset: 0,
    };
    const response = await fetchPutResponse("news/fetch_news", requestBody);
    const responseJson = await response.json();
    if (responseJson.data.length > 0) {
      //   SetOffset(offset + limit);
      //   setNewsList(responseJson.data);
      setNewsArticles(responseJson.data);
    }
    // const documentIds = responseJson.data.map((x) => {
    //   return { doc_id: x.id };
    // });

    // setDocumentIds(documentIds);
  } catch (error) {
    console.error(error);
  } finally {
    // setInUse(false);
    // setIsNewsLoading(false);
  }
};

function groupByDateAndIsin(data: any) {
  return data.reduce((acc: any, [date, score, isin]: any) => {
    const dateObj = new Date(date);
    const month = dateObj.getMonth() + 1; // getMonth is zero-based
    const year = dateObj.getFullYear();
    const key = `${year}-${month.toString().padStart(2, "0")}`; // Format as YYYY-MM

    if (!acc[key]) {
      acc[key] = { date, isin, score: 0 };
    }

    if (acc[key].isin === isin) {
      acc[key].score += score;
    } else {
      // Handle multiple ISINs case or log warning
    }

    return acc;
  }, {});
}

const processData = (data: any) => {
  if (data.length > 0) {
    const updated = data.map((dataPoint: any) => {
      const data = dataPoint.data.map((entry: any) => {
        return [entry[0], entry[1], entry[2]];
      });
      return {
        name: dataPoint.name,
        country: dataPoint.country,
        isin: dataPoint.isin,
        data: groupByDateAndIsin(data),
      };
    });

    return updated;
  }
};

function convertData1toData2(data1: any): any {
  const data2: any = { sentiment: [] };
  const keys = Object.keys(data1);
  const date = data1[keys[0]]["dates"];
  for (let i = 0; i < date.length; i++) {
    data2["sentiment"].push({
      x: date[i],
    });
    keys.map((key) => {
      data2["sentiment"][i][data1[key]["company_name"]] =
        data1[key]["scores"]["SENTIMENT_SCORE"][i];
    });
  }

  return data2;
}

export const fetchChartData = async (setChartData: any, setFilter1: any) => {
  const requestBody = {
    dashboard_name: "GEOPOLITICAL_INDIA_V1",
    frame_work: "",
    start_date: "2020-12-01",
    end_date: "2024-03-31",
    company_id: null,
    countries: null,
  };
  try {
    // setIsLoading(true);
    const response = await fetchPutResponse(
      "dashboard/fetch_dashboard_data",
      requestBody
    );
    if (!response.ok) throw new Error("Network response was not ok.");
    const { data: apiData } = await response.json();
    if (Object.keys(apiData).length !== 0) {
      const keys = Object.keys(apiData);
      const processedData = convertData1toData2(apiData);
      setChartData(processedData["sentiment"]);
      const filter1 = keys.map((key) => {
        return {
          label: apiData[key]["company_name"],
          value: apiData[key]["company_name"],
        };
      });
    } else {
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
  }
};

export const handleAddAccountId = async (
  account_id: any,
  setStatus: any,
  setError: any,
  setIsLoading: any
) => {
  setIsLoading(true);
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    const response = await fetch(
      `${apiUrl}/auth/add_account_id?account_id=${account_id}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    if (response.ok) {
      setStatus(true);
    } else {
      setStatus(false);
      setError(true);
    }
  } catch (error) {
    console.error("Error adding Account ID:", error);
    setError(true);
  } finally {
    setIsLoading(false);
  }
};

export const fetchSubscriptions = async (
  setUserSubscriptions: any,
  setSubscriptionLoading: any
) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    setSubscriptionLoading(true);
    const response = await fetch(`${apiUrl}/auth/get_subscription`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    const user_subscriptions = data.results.subscription_detail;
    const filtered_subscription = user_subscriptions.filter((x: any) => {
      return x.subscription_type === "GLOBALLINK" || x.subscription_type ==="EMALPHA";
    });
    setUserSubscriptions(filtered_subscription);
  } catch (error) {
    console.log(error);
  } finally {
    setSubscriptionLoading(false);
  }
};

export const decodeJWT = (token: any) => {
  const payloadPart = token.split(".")[1]; // Extract the payload
  const decodedPayload = atob(
    payloadPart.replace(/-/g, "+").replace(/_/g, "/")
  );
  const payloadObject = JSON.parse(decodedPayload);
  return payloadObject;
};

export const fetchUserData = async (setLoading:any, setUserProfile:any) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    setLoading(true);
    const response = await fetch(`${apiUrl}/auth:current`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    setUserProfile(data.results);
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  } finally {
    setLoading(false);
  }
};


export const fetchUserSubscriptionData = async () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const userId =localStorage.getItem("userId");
  try {
    const response = await fetch(
      `${apiUrl}/auth/get_user_subscription?user_id=${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};
